export default "__VITE_ASSET__f144ce56__"